import n, { useState as e, useRef as t, useEffect as r } from "react";
function a(n, e) {
  var t = "function" == typeof Symbol && n[Symbol.iterator];
  if (!t) return n;
  var r,
    a,
    i = t.call(n),
    l = [];
  try {
    for (; (void 0 === e || e-- > 0) && !(r = i.next()).done;) l.push(r.value);
  } catch (n) {
    a = {
      error: n
    };
  } finally {
    try {
      r && !r.done && (t = i.return) && t.call(i);
    } finally {
      if (a) throw a.error;
    }
  }
  return l;
}
var i = function i(e) {
    var t = e.children;
    return n.createElement("div", {
      className: "react-terminal-line react-terminal-input"
    }, t);
  },
  l = function l(e) {
    var t = e.children;
    return n.createElement("div", {
      className: "react-terminal-line"
    }, t);
  };
var o;
!function (n, e) {
  void 0 === e && (e = {});
  var t = e.insertAt;
  if (n && "undefined" != typeof document) {
    var r = document.head || document.getElementsByTagName("head")[0],
      a = document.createElement("style");
    a.type = "text/css", "top" === t && r.firstChild ? r.insertBefore(a, r.firstChild) : r.appendChild(a), a.styleSheet ? a.styleSheet.cssText = n : a.appendChild(document.createTextNode(n));
  }
}("/**\n * Modfied version of [termynal.js](https://github.com/ines/termynal/blob/master/termynal.css).\n *\n * @author Ines Montani <ines@ines.io>\n * @version 0.0.1\n * @license MIT\n */\n .react-terminal-wrapper {\n  width: 100%;\n  background: #252a33;\n  color: #eee;\n  font-size: 18px;\n  font-family: 'Fira Mono', Consolas, Menlo, Monaco, 'Courier New', Courier, monospace;\n  border-radius: 4px;\n  padding: 75px 45px 35px;\n  position: relative;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n }\n\n.react-terminal {\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.react-terminal-wrapper.react-terminal-light {\n  background: #ddd;\n  color: #1a1e24;\n}\n\n.react-terminal-window-buttons {\n  position: absolute;\n  top: 15px;\n  left: 15px;\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n}\n\n.react-terminal-window-buttons button {\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  border: 0;\n}\n\n.react-terminal-window-buttons button.clickable {\n  cursor: pointer;\n}\n\n.react-terminal-window-buttons button.red-btn {\n  background: #d9515d;\n}\n\n.react-terminal-window-buttons button.yellow-btn {\n  background: #f4c025;\n}\n\n.react-terminal-window-buttons button.green-btn {\n  background: #3ec930;\n}\n\n.react-terminal-wrapper:after {\n  content: attr(data-terminal-name);\n  position: absolute;\n  color: #a2a2a2;\n  top: 5px;\n  left: 0;\n  width: 100%;\n  text-align: center;\n  pointer-events: none;\n}\n\n.react-terminal-wrapper.react-terminal-light:after {\n  color: #D76D77;\n}\n\n.react-terminal-line {\n  white-space: pre;\n}\n\n.react-terminal-line:before {\n  /* Set up defaults and ensure empty lines are displayed. */\n  content: '';\n  display: inline-block;\n  vertical-align: middle;\n  color: #a2a2a2;\n}\n\n.react-terminal-light .react-terminal-line:before {\n  color: #D76D77;\n}\n\n.react-terminal-input:before {\n  margin-right: 0.75em;\n  content: '$';\n}\n\n.react-terminal-input[data-terminal-prompt]:before {\n  content: attr(data-terminal-prompt);\n}\n\n.react-terminal-wrapper:focus-within .react-terminal-active-input .cursor {\n  position: relative;\n  display: inline-block;\n  width: 0.55em;\n  height: 1em;\n  top: 0.225em;\n  background: #fff;\n  -webkit-animation: blink 1s infinite;\n          animation: blink 1s infinite;\n}\n\n/* Cursor animation */\n\n@-webkit-keyframes blink {\n  50% {\n      opacity: 0;\n  }\n}\n\n@keyframes blink {\n  50% {\n      opacity: 0;\n  }\n}\n\n.terminal-hidden-input {\n    position: fixed;\n    left: -1000px;\n}\n\n/* .react-terminal-progress {\n  display: flex;\n  margin: .5rem 0;\n}\n\n.react-terminal-progress-bar {\n  background-color: #fff;\n  border-radius: .25rem;\n  width: 25%;\n}\n\n.react-terminal-wrapper.react-terminal-light .react-terminal-progress-bar {\n  background-color: #000;\n} */\n"), function (n) {
  n[n.Light = 0] = "Light", n[n.Dark = 1] = "Dark";
}(o || (o = {}));
var c = function c(i) {
  var l = i.name,
    c = i.prompt,
    d = i.height,
    m = void 0 === d ? "600px" : d,
    s = i.colorMode,
    u = i.onInput,
    p = i.children,
    f = i.startingInputValue,
    b = void 0 === f ? "" : f,
    h = i.redBtnCallback,
    y = i.yellowBtnCallback,
    v = i.greenBtnCallback,
    w = a(e(""), 2),
    g = w[0],
    k = w[1],
    x = a(e(0), 2),
    E = x[0],
    C = x[1],
    N = t(null);
  r(function () {
    k(b.trim());
  }, [b]);
  var S = t(!1);
  r(function () {
    S.current && setTimeout(function () {
      var n;
      return null === (n = null == N ? void 0 : N.current) || void 0 === n ? void 0 : n.scrollIntoView({
        behavior: "auto",
        block: "nearest"
      });
    }, 500), S.current = !0;
  }, [p]), r(function () {
    var n, e;
    if (null != u) {
      var t = [],
        r = function r(n) {
          var e = function e() {
            var e;
            return null === (e = null == n ? void 0 : n.querySelector(".terminal-hidden-input")) || void 0 === e ? void 0 : e.focus();
          };
          null == n || n.addEventListener("click", e), t.push({
            terminalEl: n,
            listener: e
          });
        };
      try {
        for (var a = function (n) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              t = e && n[e],
              r = 0;
            if (t) return t.call(n);
            if (n && "number" == typeof n.length) return {
              next: function next() {
                return n && r >= n.length && (n = void 0), {
                  value: n && n[r++],
                  done: !n
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          }(document.getElementsByClassName("react-terminal-wrapper")), i = a.next(); !i.done; i = a.next()) {
          r(i.value);
        }
      } catch (e) {
        n = {
          error: e
        };
      } finally {
        try {
          i && !i.done && (e = a.return) && e.call(a);
        } finally {
          if (n) throw n.error;
        }
      }
      return function () {
        t.forEach(function (n) {
          n.terminalEl.removeEventListener("click", n.listener);
        });
      };
    }
  }, [u]);
  var D = ["react-terminal-wrapper"];
  return s === o.Light && D.push("react-terminal-light"), n.createElement("div", {
    className: D.join(" "),
    "data-terminal-name": l
  }, n.createElement("div", {
    className: "react-terminal-window-buttons"
  }, n.createElement("button", {
    className: (y ? "clickable" : "") + " red-btn",
    disabled: !h,
    onClick: h
  }), n.createElement("button", {
    className: (y ? "clickable" : "") + " yellow-btn",
    disabled: !y,
    onClick: y
  }), n.createElement("button", {
    className: (v ? "clickable" : "") + " green-btn",
    disabled: !v,
    onClick: v
  })), n.createElement("div", {
    className: "react-terminal",
    style: {
      height: m
    }
  }, p, u && n.createElement("div", {
    className: "react-terminal-line react-terminal-input react-terminal-active-input",
    "data-terminal-prompt": c || "$",
    key: "terminal-line-prompt"
  }, g, n.createElement("span", {
    className: "cursor",
    style: {
      left: E + 1 + "px"
    }
  })), n.createElement("div", {
    ref: N
  })), n.createElement("input", {
    className: "terminal-hidden-input",
    placeholder: "Terminal Hidden Input",
    value: g,
    autoFocus: null != u,
    onChange: function onChange(n) {
      k(n.target.value);
    },
    onKeyDown: function onKeyDown(n) {
      var e, t, r;
      if (u) if ("Enter" === n.key) u(g), C(0), k("");else if (["ArrowLeft", "ArrowRight", "ArrowDown", "ArrowUp", "Delete"].includes(n.key)) {
        var a = n.currentTarget,
          i = "",
          l = g.length - (a.selectionStart || 0);
        e = l, t = 0, r = g.length, l = e > r ? r : e < t ? t : e, "ArrowLeft" === n.key ? (l > g.length - 1 && l--, i = g.slice(g.length - 1 - l)) : "ArrowRight" === n.key || "Delete" === n.key ? i = g.slice(g.length - l + 1) : "ArrowUp" === n.key && (i = g.slice(0));
        var o = function (n, e) {
          var t = document.createElement("span");
          t.style.visibility = "hidden", t.style.position = "absolute", t.style.fontSize = window.getComputedStyle(n).fontSize, t.style.fontFamily = window.getComputedStyle(n).fontFamily, t.innerText = e, document.body.appendChild(t);
          var r = t.getBoundingClientRect().width;
          return document.body.removeChild(t), -r;
        }(a, i);
        C(o);
      }
    }
  }));
};
export { o as ColorMode, i as TerminalInput, l as TerminalOutput, c as default };
//# sourceMappingURL=index.es.js.map